import React, { Fragment } from 'react';
import classNames from 'classnames';
import { Divider, MultiSelect } from 'components';

import type { CommonFleetRuleProps, FleetRuleLeftSideTranslations } from '../fleet-rule-utils';
import type { Condition } from '../../rule/rule-utils';

import { GenericCondition } from '../../rule/components/generic-condition';
import { RuleFooter as RuleAttributes } from '../../rule/components/rule-footer';
import { FleetRuleLeftSideOptions } from '../fleet-rule-utils';
import { CheckboxAttribute } from './checkbox-attribute';

import styles from '../fleet-rule.module.scss';
import '../fleet-rule.scss';

interface FleetRuleLeftSideProps extends CommonFleetRuleProps {
	disabled?: boolean;
	overallChecked?: boolean;
	translations: FleetRuleLeftSideTranslations;
	fleetRuleLeftSideOptions: FleetRuleLeftSideOptions;
	handleCheckedOverall: (e) => void;
	handleMultiselectChange: (e) => void;
	handleChange: (c: Condition, value: unknown) => void;
	removeCondition: (c: Condition) => void;
	addCondition(key: string): void;
}

export const FleetRuleLeftSide = ({
	disabled = false,
	overallChecked = true,
	translations,
	fleetRuleLeftSideOptions,
	handleCheckedOverall,
	handleMultiselectChange,
	removeCondition,
	handleChange,
	addCondition
}: FleetRuleLeftSideProps) => {
	const conditionProps = {
		translations,
		removeCondition,
		handleChange,
		disabled
	};

	const INPUT_WIDTH = '96%';

	return (
		<>
			<div className={classNames(styles['checkbox-container'], styles['with-margin'])}>
				<div
					className={classNames(styles['checkbox-header'], {
						[styles['disabled']]: disabled
					})}
				>
					{' '}
					{translations.defineAttributes}
				</div>
				<CheckboxAttribute
					disabled={disabled}
					onChangeCheckbox={handleCheckedOverall}
					checked={overallChecked}
					title={translations.setAsOverallDefault}
					tooltipText={translations.tooltipText}
				/>
				<div data-test-id="fleet-router-rule-body-left-side-multiselect" className={styles['multiselect']}>
					<div
						className={classNames(styles['multiselect-title'], {
							[styles['disabled']]: disabled
						})}
					>
						{translations.selectTeams}
					</div>
					<MultiSelect
						disabled={fleetRuleLeftSideOptions.disabledMultiSelect || disabled}
						showArrow
						style={{ flex: 1, width: INPUT_WIDTH }}
						placeholder={translations.multiselectPlaceholder}
						options={fleetRuleLeftSideOptions.multiSelectOptions}
						value={fleetRuleLeftSideOptions.multiSelectValue}
						allowClear
						byKey
						onChange={handleMultiselectChange}
					/>
				</div>
			</div>
			<div
				data-test-id="fleet-router-rule-body-left-side-condition"
				className={classNames('fleet-rule-component-conditions-container', 'with-divider')}
			>
				{fleetRuleLeftSideOptions.conditions.map((condition, index) => {
					return (
						<Fragment key={condition.id}>
							<GenericCondition
								{...conditionProps}
								disabled={disabled}
								withIndexedLabel={false}
								key={condition.id}
								index={index}
								condition={condition}
							/>
							{index < fleetRuleLeftSideOptions.conditions.length - 1 && <Divider></Divider>}
						</Fragment>
					);
				})}
			</div>
			<RuleAttributes
				disabled={fleetRuleLeftSideOptions.attributesDisabled}
				attributes={fleetRuleLeftSideOptions.attributes}
				addCondition={addCondition}
				translations={translations}
				isFleetRule={true}
			/>
		</>
	);
};
